import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(100);
const savedMinimalSchema = z.string().max(100);
const schema = z.string().min(1).max(100);
const savedSchema = z.string().min(1).max(100);
const jsonSchema = z.string();
/**
 * 当該株を入手した機関名(値オブジェクト)のメタデータ。
 *
 *  */
export const stockProviderOrganizationNameMeta = new ValueObjectMetaString(
  "StockProviderOrganizationName",
  "\u5F53\u8A72\u682A\u3092\u5165\u624B\u3057\u305F\u6A5F\u95A2\u540D",
  messageId(
    "lbl.\u5F53\u8A72\u682A\u3092\u5165\u624B\u3057\u305F\u6A5F\u95A2\u540D"
  ),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
